import { render, staticRenderFns } from "./vsIcon.vue?vue&type=template&id=4edb0ce0&"
import script from "./vsIcon.vue?vue&type=script&lang=js&"
export * from "./vsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsIcon.vue"
export default component.exports